// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__lmrYB","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__g6mOr"};